import React, { useState, useCallback } from 'react';
import styled, { css } from 'styled-components';
import { useFormik } from 'formik';
import { Edit } from 'styled-icons/material';

import { ClientChangeDescOrMacApi, ClientChangeExtraMacApi } from '../../api/api-client';
import { FormFeedback } from './editable-content.component';
import { PrimaryBtn, SecondaryBtn, SaveBtn } from './buttons.component';

const Container = styled.form`
  width: 50%;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  margin: 10px 0;
  gap: 1rem;

  @media(max-width: 1000px) {
      gap: 0.5rem;
      padding: 0.5rem 0.2rem;
      border: 1px solid var(--korbank-purple);
  }

  @media(max-width: 1000px){
    width: 100%;
  }
`
const Title = styled.p`
  font-size: var(--content-size);
  margin: 0;

  @media(max-width: 1000px){
    font-size: var(--mobile-mini-size);
  }
`

const InputContainer = styled.div`
  flex: 1;

  @media(max-width: 1000px){
    margin: 0 10px;
  }
`

const Input = styled.input`
  @media(max-width: 1000px){
    width: 70vw;
  }
`

const Row = styled.div`
  display: flex;
  flex-wrap wrap;
  align-items: center;
  gap: 0.5rem;

  @media(min-width: 1000px) {
      gap: 1rem;
  }
`

const Value = styled.span`
  display: block;
  font-size: var(--content-size);
  font-weight: bold;
  color: var(--korbank-purple);

  @media(max-width: 1000px){
    font-size: var(--mobile-mini-size);;
  }
`

const ButtonContainer = styled.div`
  display: flex;
  gap: 0.5rem;

  @media(min-width: 1000px){
    margin-right: auto;
    gap: 1rem;
  }
`

export const EditableService = (props) => {
  const [formVisible, setFormVisible] = useState(false);
  const [serverFeedback, setServerFeedback] = useState('');

  const onEditClick = useCallback(e => {
    setFormVisible(!formVisible)
  }, [formVisible]);

  const formik = useFormik({
    initialValues: {
      field: props.value,
    },
    onSubmit: async (values) => {
      try {
        let payload = {};
        let result = '';

        // changing base service properties
        if (props.type.includes('mac') || props.type.includes('desc')) {

          if (props.type.includes('mac')) {
            payload.content_type = 'mac';
          } else if (props.type.includes('desc')) {
            payload.content_type = 'desc';
          }
          payload.comp_id = props.id;
          payload.content = values.field;

          result = await new ClientChangeDescOrMacApi(payload).put();
        // changing extra properties
        } else if (props.type.includes('extra')) {
          payload.extra_id = props.id;
          payload.mac = values.field;
          result = await new ClientChangeExtraMacApi(payload).put();
        }
        if (result.status === 200) {
          props.setRefetch(!props.refetch);
          setFormVisible(false);
        } else {
          let content = result.data.detail;
          if (!content){
            content = result.data[0];
          }
          setServerFeedback(content);
        }
      } catch (e) {
        
      }
    },
  });

  let content = '';

  if (formVisible) {
    content = <Row>
      <InputContainer>
        <FormFeedback>
          {formik.errors.field ? (
            <>{formik.errors.field}</>
          ) : null}
          {serverFeedback}
        </FormFeedback>
        <Input id="field" {...formik.getFieldProps('field')}></Input>
        <p></p>
      </InputContainer>
      <ButtonContainer>
        <SaveBtn />
        <SecondaryBtn onClick={onEditClick}>Cofnij</SecondaryBtn>
      </ButtonContainer>
    </Row>
  } else {
    content = <Row>
      <Value>{props.value}</Value>
      <ButtonContainer>
        <PrimaryBtn onClick={onEditClick}>
            <Edit height="1rem" /> Edytuj
        </PrimaryBtn>
      </ButtonContainer>
    </Row>

  }

  return (
    <Container onSubmit={formik.handleSubmit}>
      <Title>{props.name}</Title>
      {content}
    </Container>
  )
}